import React from "react";
import {
  Box,
  Typography,
  Button,
  Modal,
  CircularProgress,
} from "@mui/material";
import { Smartphone, AlertCircle, CheckCircle } from "lucide-react";
import {
  modalStyles,
  backdropStyles,
  modalContentStyles,
  iconContainerStyles,
  messageContainerStyles,
  messageTextStyles,
  buttonContainerStyles,
  activateButtonStyles,
  cancelButtonStyles,
} from "./styles";

interface DeviceConflictModalProps {
  open: boolean;
  onActivate: () => Promise<void>;
  onCancel: () => void;
  isLoading?: boolean;
}

export const DeviceConflictModal: React.FC<DeviceConflictModalProps> = ({
  open,
  onActivate,
  onCancel,
  isLoading = false,
}) => {
  const handleActivate = () => {
    if (isLoading) return;
    void onActivate().catch((error) => {
      console.error("Error in handleActivate:", error);
    });
  };

  const handleClose = (
    _event: {},
    _reason: "backdropClick" | "escapeKeyDown",
  ) => {};

  return (
    <Modal
      open={open}
      onClose={handleClose}
      sx={modalStyles}
      disableEscapeKeyDown
      disableAutoFocus
    >
      <Box sx={backdropStyles}>
        <Box sx={modalContentStyles}>
          <Box sx={iconContainerStyles}>
            <Smartphone size={32} color="#FFFFFF" strokeWidth={2.5} />
          </Box>

          <Box sx={messageContainerStyles}>
            <AlertCircle size={18} color="#D97706" strokeWidth={2.5} />
            <Typography variant="body1" sx={messageTextStyles}>
              You are already logged in on another device. Activate this device?
            </Typography>
          </Box>

          <Box sx={buttonContainerStyles}>
            <Button
              variant="contained"
              startIcon={
                isLoading ? (
                  <CircularProgress size={18} color="inherit" />
                ) : (
                  <CheckCircle size={18} />
                )
              }
              onClick={handleActivate}
              disabled={isLoading}
              sx={activateButtonStyles}
            >
              {isLoading ? "Activating..." : "Activate this device"}
            </Button>
            <Button
              variant="outlined"
              onClick={onCancel}
              disabled={isLoading}
              sx={cancelButtonStyles}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
